import * as React from 'react'
import { connect } from 'react-redux'

import * as pbi from 'powerbi-client';

declare var powerbi: pbi.service.Service;

class Report extends React.Component<any, any> {
    component: pbi.Embed;
    rootElement: HTMLDivElement;

    constructor(props) {
        super(props);
        this.component = null;
        this.state = {
            type: 'report'
        };
    }

    componentDidMount() {
        this.updateState(this.props);
    }

    
    componentDidUpdate(prevProps) {
        if (prevProps.powerBIReportToken != this.props.powerBIReportToken) {
                this.component.setAccessToken(this.props.powerBIReportToken)  
        } else if (prevProps != this.props) {            
            this.updateState(this.props);
        }
        
    }

    componentWillUnmount() {
        this.reset();
    }

    embed(config) {
        this.reset();
        this.component = powerbi.embed(this.rootElement, config);
          
        if (this.props.onEmbedded) {
            this.props.onEmbedded(this.component);
        }
        return this.component;
    }

    reset() {
        powerbi.reset(this.rootElement);
        this.component = null;
    }

    updateState(props) {
        const nextState = Object.assign({}, this.state, props, {
            settings: {
                filterPaneEnabled: false, // removes unwanted filter pane (right side)
                navContentPaneEnabled: true // this is the bottom tabs
            }
        });
        /**
         * These properties must be removed from the state object so that they don't get used in the embedConfig.
         * They would be passed to `powerbi.embed(element, embedConfig)` inside the embed() function above 
         * and attempted to be sent over postMessage; However, functions cannot be cloned and it will fail. 
         */
        delete nextState.onEmbedded;
        delete nextState.dispatch;
        this.setState(nextState, () => {
            if (this.validateConfig(this.state)) {
                return this.embed(this.state);
            }});
    }

    validateConfig(config) {
        const errors = pbi.models.validateReportLoad(config);
        return (errors === undefined);
    }

    render() {
        return (
            <div className='powerbi-frame' ref={(ref) => this.rootElement = ref}></div>
        )
    }
}

function mapStateToProps(state) {
    return {
        powerBIReportToken: state.powerBIReducer.powerBIReportToken,
    }
}

export default connect(mapStateToProps)(Report);


// WEBPACK FOOTER //
// ./src/components/powerBIComponents/Report.tsx